<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="row">
              <div class="col-xs-12 text-left">
                <!--
                <div class="form-group text-left">
                  <router-link to="/cashAccountTable">
                    <div class="btn btn-default btn-table-title">返回帳務列表</div>
                  </router-link>
                </div>
                -->
              </div>
            </div>
          </div>
          <div class="box-body form-left">
            <div class="row">
              <div class="col-xs-12">
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      帳務ID
                    </span>
                    <div class="form-control form-info">
                      {{accountInfo.accounting_id}}
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      訂單ID
                    </span>
                    <div class="form-control form-info">
                      <router-link target="_blank" :to="'/orderInfo/' + accountInfo.order_id">{{accountInfo.order_id}}</router-link>&nbsp;&nbsp;
                      <button class="btn btn-default" data-target="#orderModal" data-toggle="modal" @click="checkOrderInfo">訂單交易資訊</button>
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      付款類型
                    </span>
                    <div class="form-control form-info">
                      <span v-if="accountInfo.vendor_type === 707" class="label label-success">LINE PAY</span>
                      <span v-else-if="accountInfo.vendor_type === 701"  class="label label-success">iPASS MONEY</span>
                      <span v-else-if="accountInfo.vendor_type === 710"  class="label label-primary">信用卡</span>
                      <span v-else-if="accountInfo.vendor_type === 713"  class="label label-warning">台灣Pay</span>
                      <span v-else-if="accountInfo.vendor_type === 716"  class="label label-primary">全盈+PAY</span>
                      <span v-else-if="accountInfo.vendor_type === 717"  class="label label-primary">悠遊付</span>
                      <span v-else-if="accountInfo.vendor_type === 718"  class="label label-info">Pi 拍錢包</span>
                      <span v-else-if="accountInfo.vendor_type === 719"  class="label label-warning">全支付</span>
                      <span v-else-if="accountInfo.vendor_type === 720"  class="label label-info">icash Pay</span>
                      <span v-else-if="accountInfo.vendor_type === 908"  class="label label-danger">街口支付</span>
                      <span v-else-if="accountInfo.vendor_type === 909"  class="label label-danger">遠傳電信代收</span>
                      <span v-else  class="label label-warning">其他</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      交易類型
                    </span>
                    <div class="form-control form-info">
                      <span v-if="accountInfo.accounting_type === 1" class="label label-success">付款</span>
                      <span v-else-if="accountInfo.accounting_type === 2"  class="label label-danger">退款</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      對帳進度
                    </span>
                    <div class="form-control form-info">
                      <span v-if="accountInfo.is_confirmed" class="label label-success">已完成</span>
                      <span v-else-if="!accountInfo.is_confirmed"  class="label label-danger">未完成</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      最後狀態
                    </span>
                    <div class="form-control form-info">
                      <span v-if="accountInfo.latest_status === 1"  class="label label-success">成功</span>
                      <span v-else-if="accountInfo.latest_status === 2"  class="label label-danger">失敗 訂單帳務有衝突</span>
                      <span v-else-if="accountInfo.latest_status === 3"  class="label label-danger">成功 帳務紀錄有缺</span>
                      <span v-else-if="accountInfo.latest_status === 4"  class="label label-danger">成功 帳務記錄冗余</span>
                      <span v-else class="label label-default">尚未對帳</span>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <div class="box-body form-right">
            <div>
              <div class="input-group">
                    <span class="input-group-addon">
                      交易編號 (ID)
                    </span>
                <div class="form-control form-info">
                  {{accountInfo.trade_no}} ({{accountInfo.trade_id}})
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                    <span class="input-group-addon">
                      交易金額
                    </span>
                <div class="form-control form-info">
                  $ {{accountInfo.money}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                    <span class="input-group-addon">
                      交易日期
                    </span>
                <div class="form-control form-info">
                  {{accountInfo.trade_date}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                    <span class="input-group-addon">
                      更新時間
                    </span>
                <div class="form-control form-info">
                  {{accountInfo.update_time}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                    <span class="input-group-addon">
                      建立時間
                    </span>
                <div class="form-control form-info">
                  {{accountInfo.create_time}}
                </div>
              </div>
              <br />
            </div>
          </div>
          <div class="box-body form-center">
            <div class="col-xs-12 table-responsive p-x-0">
              <br>
              <h5>對帳歷史紀錄</h5>
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">對帳ID</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">對帳狀態</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">備註</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>
                </tr>
                </thead>
                <tbody>
                <tr class="even" role="row" v-for="(track, index) in trackingList">
                  <td>{{index + 1}}</td>
                  <td>{{track.tracking_id}}</td>
                  <td>
                    <span v-if="track.status === 1"  class="label label-success">成功</span>
                    <span v-else-if="track.status === 2"  class="label label-danger">失敗 訂單帳務有衝突</span>
                    <span v-else-if="track.status === 3"  class="label label-danger">失敗 帳務紀錄有缺</span>
                    <span v-else-if="track.status === 4"  class="label label-danger">失敗 帳務記錄冗余</span>
                    <span v-else class="label label-default">尚未對帳</span>
                  </td>
                  <td>{{track.change_remark}}</td>
                  <td>{{track.create_time}}</td>
                </tr>
                </tbody>
              </table>
              <br><br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="orderModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">訂單交易資訊</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <pre id="order-info"></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
export default {
  name: 'Tables',
  data () {
    return {
      accountInfo: {},
      trackingList: [],
      orderInfo: {},
      orderGet: false
    }
  },
  mounted () {
  },
  methods: {
    checkOrderInfo () {
      if (!this.orderGet) this.getOrderInfo()
    },
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    getAccountInfo () {
      var self = this
      var url = '/accounting/log/' + this.$route.params.accounting_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.accountInfo = response.data.log
          self.trackingList = self.accountInfo.tracking_list
        }
      })
    },
    getOrderInfo () {
      var self = this
      var url = '/accounting/orderTradeInfo/' + this.accountInfo.order_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.orderInfo = response.data.trade_info
          self.orderGet = true
          $('#order-info').html(JSON.stringify(self.orderInfo, null, 2))
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.fixedH()
    this.getAccountInfo()
  }
}
</script>



// WEBPACK FOOTER //
// CashAccountInfo.vue?724079de